import React, {useEffect, useState} from 'react'
import {connect, useDispatch} from 'react-redux'
import {Avatar, Button, DatePicker, Divider, Dropdown, Grid, Menu, Modal, Popover, Spin, Table} from "antd"
import {Subtitle1} from '../../../components'
import {
  appLog,
  dialogCloser,
  emptyFun,
  emptyOrders,
  formSubmitButton,
  getOrderStatus,
  getSkels,
  horStack,
  keyValItemOrders,
  makeAutoCompleteOptions,
  modalClose,
  onTableChange,
  outlinedButton,
  responsiveTbl,
  secondaryButton,
  stateFilter
} from "../../../common/helpers";


import {bulkUpdateOrderStatus, fetchPatientOrders, resetOrdersPagination, selectOrder, updatePatientDmeOrdersFilters} from '../../../app/Reducers';
import TableFilters from "../../../components/InputComponents/TableFilters";
import dayjs from 'dayjs';


import {CaretDownOutlined, FieldTimeOutlined, LoadingOutlined} from '@ant-design/icons';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {apiRequest} from '../../../app/Apis';
import {genOrdersReport, genSingleOrderReport, getOrderFilterStatuses} from "../../../app/Apis/commonApi";
import AuditLogViewer from "../../../components/AuditLogs/AuditLogViewer";

import _ from "lodash"
import PatientOrderPreview from './PatientOrderPreview';
import ReportForm from './ReportForm';
import PdfViewer from '../../../components/PdfViewer';
import {usePermissionCheck} from '../../../hooks/usePermissionCheck';

var isoWeek = require('dayjs/plugin/isoWeek')
dayjs.extend(isoWeek)

const groupedItems = (data) => {
  const groupedByCompany = _.groupBy(data, 'biologic_product.company_name');
  
  // Get unique sizes for each company
  const uniqueSizes = _.mapValues(groupedByCompany, (items) => _.uniqBy(items, 'size'));
  
  // Add count of sizes to each object
  const result = _.mapValues(uniqueSizes, (items) => {
    return _.map(items, (item) => {
      return { ...item, count: _.filter(groupedByCompany[item.biologic_product.company_name], { 'size': item.size }).length }
    });
  });
  return result
}


const DateRangePicker = ({ onSave }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  
  const handleSave = () => {
    setVisible(false)
    onSave({ startDate, endDate });
    
  };
  
  const [visible, setVisible] = useState(false);
  
  const handleVisibleChange = (visible) => {
    setVisible(visible);
  }
  const disabledDate = (current) => {
    // if (!startDate) {
    //     // Disable all dates if start date is not selected
    //     return true;
    // }
    
    // Allow only 30 days range between start and end date
    return (
      current &&
      (current < dayjs(startDate).startOf('day') ||
        current > dayjs(startDate).add(30, 'days').endOf('day') ||
        current > dayjs(endDate).endOf('day'))
    );
  };
  
  
  const content = (
    <div>
      <DatePicker.RangePicker
        onChange={handleDateChange}
        // disabledDate={disabledDate}
      />
      <Button className="ml-2" type="primary" onClick={handleSave}>Generate</Button>
    </div>
  );
  
  return (
    <Popover open={visible}
             onOpenChange={handleVisibleChange} content={content} title="Select Date Range" trigger="click" placement="left">
      <Button type="primary">Generate report</Button>
    </Popover>
  );
};
const { useBreakpoint } = Grid;
const PatientDMEList = ({ ordersPagination, appConf, navs, orders, activeUser, patient, order }) => {
  // picker stuff for report
  const windowState=useBreakpoint()
  const [isOpen, setOpen] = useState(false)
  const [previewisOpen, setpreviewOpen] = useState(false)
  const [selectedOrder, setselectedOrder] = useState(null)
  const dispatch = useDispatch()
  const [isVisible, setIsVisible] = useState(false);
  const [isExecuting, setisExecuting] = useState(false)
  const [availableStatuses, setavailableStatuses] = useState([])
  const [dmeOrders, setDMEOrders] = useState(orders?.filter(item => item.visit_type === 'DME'))
  const [orderStatuses, setOrderStatuses] = useState([])
  const [showAuditDialog, setShowAuditDialog] = useState(false);
  const can_export_treatment_order = usePermissionCheck('export_treatment_order', false, [])
  
const can_view_audit_logs = usePermissionCheck('view_audit_logs', false, [])
  const can_view_dme_orders = usePermissionCheck('view_dme_orders', false, [])
  const can_view_biologic_orders = usePermissionCheck('view_biologic_orders', false, [])
  // const [order, setOrder] = useState(null);
  
  let onCell = (record, rowIndex) => ({
    onClick: event => {
      (async () => {
        selectOrdere(record)
      })().catch(appLog)
    }
  })
  const columns = [
    {
      title: 'Provider', dataIndex: ['consultant', 'name'], key: 'consultant', fltr: { filterable: true, type: 'text' },
      sorter: { multiple: 3, compare: (a, b) => a?.consultant?.name < b?.consultant?.name }, onCell
    },
    // {
    //     title: 'Patient', dataIndex: ['patient', 'name'], key: 'patient', fltr: { filterable: true, type: 'text' }, onCell,
    //     sorter: { multiple: 3, compare: (a, b) => a?.patient?.name?.toLowerCase().localeCompare(b?.patient?.name?.toLowerCase()) },
    // },
    {
      title: 'Order date', dataIndex: 'created_at', key: 'createdAt', fltr: { filterable: true, type: 'date' }, onCell,
      render: (created_at, record) => (<Subtitle1 style={{ textAlign: 'left' }}>{dayjs(created_at).format("MM/DD/YYYY")}</Subtitle1>)
    },
    //baseKey is used as form field name on the Filters form while keys attr is used to name filter API parameters
    {
      title: 'DOS', dataIndex: 'date_of_service', key: 'date_of_service',
      fltr: { filterable: true, type: 'date_range', keys: ['dateOfServiceRange[start_at]', 'dateOfServiceRange[end_at]'], baseKey: 'date_of_service_filter' },
      render: (date_of_service, record) => (<Subtitle1 style={{ textAlign: 'left' }}>{dayjs(date_of_service).format("MM/DD/YYYY")}</Subtitle1>), onCell
    },
    {
      title: 'Delivery Date', dataIndex: 'delivered_date', key: 'delivered_date',
      fltr: { filterable: false, type: 'date_range', keys: ['dateOfServiceRange[start_at]', 'dateOfServiceRange[end_at]'], baseKey: 'date_of_service_filter' },
      render: (delivered_date, record) => (<Subtitle1 style={{ textAlign: 'left' }}>{delivered_date ? dayjs(delivered_date).format("MM/DD/YYYY") : ""}</Subtitle1>), onCell
    },
    
    {
      title: 'Week no', dataIndex: 'date_of_service', key: 'weekNumber', fltr: { filterable: true, type: 'number' },
      render: (date_of_service, record) => (<Subtitle1 style={{ textAlign: 'left' }}>{dayjs(date_of_service).isoWeek()}</Subtitle1>), onCell
    },
    { ...stateFilter, title: 'State', dataIndex: 'state', key: 'state', onCell },
    {
      title: 'Office', dataIndex: ['patient', 'facility'], key: 'facility', fltr: { filterable: true, type: 'text' }, onCell
    },
    {
      title: 'Wound Location', key: 'wound_location', fltr: { filterable: true, type: 'text' }, onCell,
      
      render: (record) => record.visit_type === "Biologics" ?
        <Popover style={{ cursor: 'pointer' }}
                 content={<div>
                   {Object.keys(groupedItems(record.biologic_kits)).map(item => {
                       return (<div>
                         {keyValItemOrders('Treatment Number:', `${record.assessment_observations?.treatment_number}`)}
                         
                         {keyValItemOrders('Product Name:', `${item} ${record.biologic_kits[0]?.biologic_product?.product_name}`)}
                         {keyValItemOrders('Wound Size (Area):', `${record.assessment_observations?.area}cm`, "2")}
                         {keyValItemOrders('Recommended Grafts:', ([].concat(Object.values(groupedItems(record.biologic_kits)))[0].map(item => (`${item?.size}(${item.count})`))).toString())}
                         <Divider/>
                       </div>)
                     }
                   )}
                 </div>
                 }
        
        >
          
          <p style={{ cursor: 'pointer' }}>{record.wound_location}</p>
        </Popover> : <p style={{ cursor: 'pointer' }}>{record.wound_location}</p>
    },
    
    {
      onCell,
      key: 'visitType', title: 'Order type', dataIndex: 'visit_type',
      render: (visit_type, record) => visit_type === "Biologics" ?
        <Popover style={{ cursor: 'pointer' }}
                 content={<div>
                   {Object.keys(groupedItems(record.biologic_kits)).map(item => {
                       return (<div>
                         {keyValItemOrders('Treatment Number:', `${record.assessment_observations?.treatment_number}`)}
                         {keyValItemOrders('Product Name:', `${item} ${record.biologic_kits[0]?.biologic_product?.product_name}`)}
                         {keyValItemOrders('Wound Size (Area):', `${record.assessment_observations?.area}cm`, "2")}
                         {keyValItemOrders('Recommended Grafts:', ([].concat(Object.values(groupedItems(record.biologic_kits)))[0].map(item => (`${item?.size}(${item.count})`))).toString())}
                         
                         <Divider/>
                       </div>)
                     }
                   )}
                 </div>
                 }
        >
          
          <p style={{ cursor: 'pointer' }}>{visit_type}</p>
        </Popover> : visit_type,
      fltr: {
        filterable: false, type: 'autocomplete',
        options: makeAutoCompleteOptions([
          ...(can_view_dme_orders ? ['DME'] : []),
          ...(can_view_biologic_orders ? ['biologics'] : []), 'internal'])
      }
    },
    {
      onCell,
      title: 'Status', dataIndex: 'status', key: 'status', fltr: {
        filterable: true, type: 'autocomplete', options: makeAutoCompleteOptions(orderStatuses)
      }, render: (status) => getOrderStatus(status?.toLowerCase())
    },
    // generate report button not showing this button
    {
      title: '', dataIndex: '', key: 'x', render: (text, record, index) => record.assessment_status === "approved" && <Button onClick={async () => {
        handleCreateSingleReport(record)
        
      }} type="primary">Report</Button>
    },
    
    ...(can_view_audit_logs ?
      [{
        title: '', dataIndex: '', key: 'x', render: (text, record, index) => <Button onClick={async () => {
          await dispatch(selectOrder(record))
          await setselectedOrder(record)
          await setShowAuditDialog(true)
          
        }} type="dashed" icon={<FieldTimeOutlined/>}>Audit</Button>
      }] : [])
  
  ]
  useEffect(() => {
    loadOrders().catch(appLog)
    getOrderFilterStatuses(setOrderStatuses, 'dme').catch(appLog)
    getStatuses().catch(appLog)
    return emptyFun
  }, [])
  const getStatuses = async () => {
    let data = await apiRequest.get(`/treatment-order-statuses`).catch(e => appLog(e))
    if (data && data.data) {
      setavailableStatuses(data.data.data)
    }
  }
  
  useEffect(() => {
    setSelectedRowKeys([])
    setDMEOrders(orders?.filter(item => item.visit_type === 'DME'))
    return emptyFun
  }, [orders])
  const loadOrders = async () => {
    await dispatch(updatePatientDmeOrdersFilters([appConf.patientDmeOrdersFilters[0], appConf.patientDmeOrdersFilters[1], true]))
    await dispatch(fetchPatientOrders(appConf.patientDmeOrdersFilters[0] ? { ...appConf.patientDmeOrdersFilters[1] } : { filterData: { "patientId": patient.id, "visitType": 'DME' } }))
    await dispatch(updatePatientDmeOrdersFilters([appConf.patientDmeOrdersFilters[0], appConf.patientDmeOrdersFilters[1], false]))
  }
  
  const handleFilterAction = async (action, values) => {
    // appLog({action, values})
    await dispatch(resetOrdersPagination())
    if (action === 'filter') {
      let pl = { filterData: { ...values, "patientId": patient.id, "visitType": 'DME' }, pagination: ordersPagination }
      await dispatch(updatePatientDmeOrdersFilters([false, pl, true]))
      await dispatch(fetchPatientOrders(pl))
      await dispatch(updatePatientDmeOrdersFilters([true, pl, false]))
    }
    if (action === 'reset') {
      await dispatch(updatePatientDmeOrdersFilters([appConf.patientDmeOrdersFilters[0], undefined, true]))
      await dispatch(fetchPatientOrders({ "filterData": { "patientId": patient.id, "visitType": 'DME' } }))
      await dispatch(updatePatientDmeOrdersFilters([false, undefined, false]))
    }
    setIsVisible(false)
  }
  
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    // appLog('selectedRowKeys changed: ', selectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  
  const rowSelection = { selectedRowKeys, onChange: onSelectChange };
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const handleMenuClick = (e) => {
    let payload = { dmeOrders: [...selectedRowKeys], status: availableStatuses?.filter(item => !reasonableStatuses.includes(item))[e.key] }
    // appLog(e, payload)
    let data = { payload, filters: { "filterData": { "patientId": patient.id, "visitType": 'DME' } } }
    dispatch(bulkUpdateOrderStatus(data))
  }
  
  
  /*  const import_orders = async () => {
      let pl = appConf.patientDmeOrdersFilters[1]
      await dispatch(downloadOrders(pl))
      
    }*/
  const reasonableStatuses = ["cancelled", "needs review", "returned"]
  const menu = (<Menu onClick={handleMenuClick}>
    {availableStatuses?.filter(item => !reasonableStatuses.includes(item)).map((item, index) => <Menu.Item key={index}
                                                                                                           style={{ textTransform: 'capitalize' }}> {item.replace('-', '').replace(/_/g, ' ')}  </Menu.Item>)}
  </Menu>);
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderExportForm, setOrderExportForm] = useState(false)
  const handleExportOrderCancel = () => {
    setOrderExportForm(false)
  }
  
  const selectOrdere = async (order) => {
    await dispatch(selectOrder(order))
    await setselectedOrder(order)
    await fetchPatientById()
    await fetchConsultantById()
    setpreviewOpen(true)
  }
  
  const [consultant, setconsultant] = useState(null)
  const [orderPatient, setorderPatient] = useState(null)
  
  
  const fetchConsultantById = async () => {
    if (selectedOrder?.consultant) {
      const response = await apiRequest.get(`/consultants/${selectedOrder.consultant.id}`)
      const consultant = response?.data?.data
      if (consultant) {
        const shippingResponse = await apiRequest.get(`/shipping-addresses?user=${consultant.user_id}`)
        const consultant_addresses = shippingResponse?.data?.data
        consultant.addresses = [...consultant_addresses]
      }
      setconsultant(consultant)
      
    }
  }
  
  const fetchPatientById = async () => {
    
    
    const _patient = { ...patient }
    if (_patient) {
      const shippingResponse = await apiRequest.get(`/shipping-addresses?user=${patient.user_id}`)
      const patient_addresses = shippingResponse?.data?.data
      _patient.addresses = [...patient_addresses]
    }
    setorderPatient(_patient)
    
  }
  const handleCreateReport = async (dates) => {
    console.log(dates)
    let start_at = dayjs(dates.startDate).format("YYYY-MM-DD")
    let end_at = dayjs(dates.endDate).format("YYYY-MM-DD")
    
    await dispatch(genOrdersReport(patient.id, start_at, end_at, setWoundsProgressPrinting, setStatusModal, setPdf, setLoading, setPdfShowing))
    
  }
  
  const handleCreateSingleReport = async (record) => {
    
    
    await dispatch(genSingleOrderReport(patient.id, record, setWoundsProgressPrinting, setStatusModal, setPdf, setLoading, setPdfShowing))
    
  }
  
  
  const [isWoundsProgressPrinting, setWoundsProgressPrinting] = useState(false)
  const [visitStatusModal, setStatusModal] = useState(false)
  const [pdfShowing, setPdfShowing] = useState(false);
  const [pdfLoading, setLoading] = useState(false);
  const [pdf, setPdf] = useState(null);
  
  return (
    (<div className="main-page">
      <PdfViewer pdf={pdf} setLoading={setLoading} loading={pdfLoading} onCancel={() => setPdfShowing(false)} visible={pdfShowing}/>
      {(showAuditDialog && !!selectedOrder) && <AuditLogViewer visible={showAuditDialog} onCancel={dialogCloser(setShowAuditDialog)} loading={false} resourceDescription={'Treatment order'}
                                                               resourceType={'Treatment order'}
                                                               defaultValues={{ auditableId: selectedOrder.id, auditable: 'treatment_order', format: 'json' }}/>}
      <Modal
        title="Order Report"
        open={orderExportForm}
        destroyOnClose
        onCancel={handleExportOrderCancel}
        closeIcon={modalClose(handleExportOrderCancel)}
        maskClosable={false}
        footer={[<div className="entity-filters flex-boy-row" style={{ justifyContent: 'flex-end' }}>
          {horStack([outlinedButton(() => setOrderExportForm(false), 'Cancel', isExecuting),
            formSubmitButton('new-order-report', 'Download', isExecuting, 'Downloading')])}
        </div>]}>
        <ReportForm closeModal={handleExportOrderCancel} setIsSubmitting={setIsSubmitting} type={"dme"}/>
      </Modal>
      <Modal
        title={`Order ${selectedOrder?.id || ''} Details`}
        open={previewisOpen && selectedOrder}
        onOk={dialogCloser(setpreviewOpen)}
        onCancel={dialogCloser(setpreviewOpen)}
        closeIcon={modalClose(dialogCloser(setpreviewOpen))}
        maskClosable={false}
        destroyOnClose={true}
        width={600}
        footer={activeUser?.facilityProfile ? null : [<div className="entity-filters flex-boy-row" style={{ justifyContent: 'flex-end' }}>
          {horStack([
            outlinedButton(dialogCloser(setpreviewOpen), 'Cancel', isExecuting),
            formSubmitButton('patientOrderpreviewForm', 'Save', isExecuting, 'Updating')])}
        </div>]}>
        
        
        {selectedOrder ? <PatientOrderPreview setpreviewOpen={setpreviewOpen} loadOrders={loadOrders} isExecuting={isExecuting} setisExecuting={setisExecuting} consultant={consultant} patient={orderPatient}
          order={selectedOrder} /> : null}
      </Modal>
      <div className="w-full">
        
        <Table
          // sortDirections={['ascend', 'descend', 'ascend']}
          rowKey={(record) => record.id}
          // rowSelection={!activeUser?.facilityProfile && availableStatuses?.filter(item => !reasonableStatuses.includes(item)).length > 0 && rowSelection}
          title={() => (
            <>
              <TableFilters datasource={[...columns]} setIsVisible={setIsVisible}
                            isVisible={isVisible}
                            showClear={appConf.patientDmeOrdersFilters[0]}
                            handleFilterAction={handleFilterAction}
                            loading={appConf.patientDmeOrdersFilters[2]}
                            filters={appConf.patientDmeOrdersFilters[1]}
                            actionButton={
                              <div className="flex-boy-row" style={{ justifyContent: 'flex-end', alignItems: 'center' }}>
                                {/* <DateRangePicker onSave={handleCreateReport}/> */}
                                {can_export_treatment_order &&
                                  <Button type={'default'} size={'middle'} onClick={() => setOrderExportForm(true)}
                                          icon={<FontAwesomeIcon icon={["far", 'file-excel']}/>}>Export to CSV
                                  </Button>}
                              
                              
                              </div>
                            }
              />
              {selectedRowKeys.length > 0 && <div className="flex-boy-row-space" style={{ backgroundColor: 'teal', marginTop: '10px' }}>
                <Subtitle1 color="white">Selected: {selectedRowKeys.length}</Subtitle1>
                <Dropdown dropdownRender={()=>menu} trigger={['click']}>
                  {secondaryButton(null, "Change Status", updatingStatus, 'Updating',
                    { backgroundColor: 'white' }, {
                      endIcon: <CaretDownOutlined/>
                    })}
                </Dropdown>
              </div>}
            </>
          )}
          loading={appConf.patientDmeOrdersFilters[2]} {...responsiveTbl(windowState)} locale={{ emptyText: emptyOrders('orders.') }}
          onChange={(pagination, filters,
                     sorter) => onTableChange(pagination, filters, sorter, dispatch, fetchPatientOrders, appConf.patientDmeOrdersFilters, updatePatientDmeOrdersFilters, {
            "patientId": patient.id,
            "visitType": 'DME'
          }, ordersPagination)}
          onRow={(record, rowIndex) => {
            return {
              onClick: event => {
              } // click row
            };
          }}
          {...getSkels(appConf.patientDmeOrdersFilters[2], columns, dmeOrders)}
          pagination={ordersPagination}
        />
      </div>
    </div>)
  );
}

const mapStateToProps = (state) => ({
  
  orders: state.patients.orders,
  patientOrdersPagination: state.patients.patientOrdersPagination,
  ordersPagination: state.patients.patientDmeOrdersPagination,
  appConf: state.appConf,
  navs: state.navs, activeUser: state.auth.activeUser,
  patient: state.patients.selectedPatient,
  order: state.orders.selectedOrder
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PatientDMEList)
